// src/components/Logs/LogAcessoTable.js
import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  IconButton,
  Chip,
  CircularProgress
} from '@mui/material';
import {
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import { formatarData } from '../../utils/formatters';

const LogAcessoTable = ({ logs, loading, onDetailsClick }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'SUCESSO':
        return 'success';
      case 'FALHA':
        return 'error';
      default:
        return 'default';
    }
  };

  const getTipoAcessoColor = (tipo) => {
    switch (tipo) {
      case 'LOGIN':
        return 'primary';
      case 'LOGOUT':
        return 'info';
      case 'FALHA_LOGIN':
        return 'error';
      case 'RECUPERACAO_SENHA':
        return 'warning';
      default:
        return 'default';
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (!logs.length) {
    return (
      <Box p={3} textAlign="center">
        <Typography color="textSecondary">
          Nenhum log de acesso encontrado
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Data/Hora</TableCell>
            <TableCell>Usuário</TableCell>
            <TableCell>Tipo Acesso</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>IP</TableCell>
            <TableCell>User Agent</TableCell>
            <TableCell>Detalhes</TableCell>
            <TableCell align="center">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs.map((log) => (
            <TableRow key={log.id}>
              <TableCell>{formatarData(log.created_at)}</TableCell>
              <TableCell>{log.usuario?.nome || 'Sistema'}</TableCell>
              <TableCell>
                <Chip
                  label={log.tipo_acesso}
                  size="small"
                  color={getTipoAcessoColor(log.tipo_acesso)}
                  variant="outlined"
                />
              </TableCell>
              <TableCell>
                <Chip
                  label={log.status}
                  size="small"
                  color={getStatusColor(log.status)}
                />
              </TableCell>
              <TableCell>{log.ip || '-'}</TableCell>
              <TableCell>
                <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                  {log.user_agent || '-'}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                  {log.detalhes ? JSON.stringify(log.detalhes) : '-'}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <IconButton 
                  size="small"
                  onClick={() => onDetailsClick(log)}
                >
                  <VisibilityIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

LogAcessoTable.propTypes = {
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      created_at: PropTypes.string.isRequired,
      usuario: PropTypes.shape({
        nome: PropTypes.string
      }),
      tipo_acesso: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      ip: PropTypes.string,
      user_agent: PropTypes.string,
      detalhes: PropTypes.object
    })
  ).isRequired,
  loading: PropTypes.bool.isRequired,
  onDetailsClick: PropTypes.func.isRequired
};

LogAcessoTable.defaultProps = {
  logs: [],
  loading: false,
  onDetailsClick: () => {}
};

export default LogAcessoTable;